import { call, takeLatest, put } from "redux-saga/effects"
import {
  requestRolesListByFilters,
  requestUpsertRoles,
  requestDeleteAppRoles,
} from "appRedux/sagas/requests/rolesList"
import {
  getRolesListByFilters,
  getRolesListByFiltersSuccess,
  upsertRoles,
  upsertRolesSuccess,
  deleteRoles,
  deleteRolesSuccess,
  resetState,
} from "appRedux/slices/rolesList"
import { fetchError } from "appRedux/slices/common"
import toastr from "toastr"
import "toastr/build/toastr.min.css"

function* handleGetRolesListByFilters(params) {
  try {
    const data = yield call(requestRolesListByFilters, params)
    yield put(getRolesListByFiltersSuccess(data))
  } catch (error) {
    yield put(fetchError(error))
  }
}

function* handleUpsertRoleGenerator({ payload }) {
  try {
    const data = yield call(requestUpsertRoles, payload)
    if (data) {
      yield put(upsertRolesSuccess(data))
    }
  } catch (error) {
    toastr.error("Action Failed !!")
    yield put(fetchError(error))
  }
}

function* handleDeleteRoleGenerator({ payload }) {
  try {
    const data = yield call(requestDeleteAppRoles, payload)
    yield put(deleteRolesSuccess(data.data))
  } catch (error) {
    toastr.error("Action Failed !!")
    yield put(fetchError(error))
  }
}

export default function* watcherSaga() {
  yield takeLatest(getRolesListByFilters.type, handleGetRolesListByFilters)
  yield takeLatest(upsertRoles.type, handleUpsertRoleGenerator)
  yield takeLatest(deleteRoles.type, handleDeleteRoleGenerator)
}
